"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_core_1 = require("@mineko/js-core");
var Sentry = __importStar(require("@sentry/browser"));
var _a = process.env, REACT_APP_LOGGER_URL = _a.REACT_APP_LOGGER_URL, LOGGER_URL = _a.LOGGER_URL, REACT_APP_ENV = _a.REACT_APP_ENV, APP_ENV = _a.APP_ENV, NODE_ENV = _a.NODE_ENV;
var providerConfig = {
    url: REACT_APP_LOGGER_URL || LOGGER_URL || '',
    environment: REACT_APP_ENV || APP_ENV || NODE_ENV || '',
};
var loggerConfig = {
    debug: providerConfig.environment === 'development',
};
var provider = new js_core_1.SentryProvider(providerConfig, Sentry);
exports.default = new js_core_1.Logger(provider, loggerConfig);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvTG9nZ2VyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDJDQUF5RDtBQUN6RCxzREFBMEM7QUFFcEMsSUFBQSxLQU1GLE9BQU8sQ0FBQyxHQUFHLEVBTGIsb0JBQW9CLDBCQUFBLEVBQ3BCLFVBQVUsZ0JBQUEsRUFDVixhQUFhLG1CQUFBLEVBQ2IsT0FBTyxhQUFBLEVBQ1AsUUFBUSxjQUNLLENBQUM7QUFFaEIsSUFBTSxjQUFjLEdBQUc7SUFDckIsR0FBRyxFQUFFLG9CQUFvQixJQUFJLFVBQVUsSUFBSSxFQUFFO0lBQzdDLFdBQVcsRUFBRSxhQUFhLElBQUksT0FBTyxJQUFJLFFBQVEsSUFBSSxFQUFFO0NBQ3hELENBQUM7QUFFRixJQUFNLFlBQVksR0FBRztJQUNuQixLQUFLLEVBQUUsY0FBYyxDQUFDLFdBQVcsS0FBSyxhQUFhO0NBQ3BELENBQUM7QUFFRixJQUFNLFFBQVEsR0FBRyxJQUFJLHdCQUFjLENBQUMsY0FBYyxFQUFFLE1BQWEsQ0FBQyxDQUFDO0FBRW5FLGtCQUFlLElBQUksZ0JBQU0sQ0FBQyxRQUFRLEVBQUUsWUFBWSxDQUFDLENBQUMifQ==